import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Dialog, SharedModule } from '@vendure/admin-ui/core';

export interface ArchiveStoreSiteDialogResult {
    confirmed: boolean;
}

@Component({
    selector: 'vdr-archive-store-site-dialog',
    templateUrl: './archive-store-site-dialog.component.html',
    styleUrls: ['./archive-store-site-dialog.component.scss'],
    standalone: true,
    imports: [SharedModule, ReactiveFormsModule],
})
export class ArchiveStoreSiteDialogComponent implements Dialog<ArchiveStoreSiteDialogResult> {
    resolveWith: (result?: ArchiveStoreSiteDialogResult) => void;

    /**
     * The store site to be archived, passed via ModalService.locals
     */
    storeSite: any;

    confirmationControl = new FormControl('');

    get storeName(): string {
        return this.storeSite?.name || 'this store site';
    }

    get hasActiveSubscription(): boolean {
        // Check if the store site has an active subscription
        return this.storeSite?.sellerChannel?.customFields?.subscriptionEnabled ? true : false;
    }

    get isConfirmationValid(): boolean {
        if (this.hasActiveSubscription) {
            return false;
        }
        return this.confirmationControl.value === this.storeSite?.identifier;
    }

    cancel() {
        this.resolveWith();
    }

    confirm() {
        if (this.isConfirmationValid) {
            this.resolveWith({ confirmed: true });
        }
    }
}

